import type { CSSProperties } from 'react';

/** Default fade band for horizontal overflow (capability pill tray). */
export const HORIZONTAL_SCROLL_EDGE_FADE_PX = 36;

/**
 * CSS mask that dissolves content at the left/right edges of a horizontal
 * scrollport — avoids painting gradients over decorative backgrounds.
 */
export function buildHorizontalScrollEdgeMaskStyle(
  showLeftFade: boolean,
  showRightFade: boolean,
  fadePx = HORIZONTAL_SCROLL_EDGE_FADE_PX,
): CSSProperties | undefined {
  if (!showLeftFade && !showRightFade) return undefined;
  const leftPx = showLeftFade ? fadePx : 0;
  const rightPx = showRightFade ? fadePx : 0;
  const maskImage = `linear-gradient(to right, transparent 0, black ${leftPx}px, black calc(100% - ${rightPx}px), transparent 100%)`;
  return {
    maskImage,
    WebkitMaskImage: maskImage,
  };
}
